import React, { useState } from 'react'
import { FaEye, FaUsers } from 'react-icons/fa';
import SlidingDiv from '../../../components/SlidingDiv';
import { useOutletContext } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useAuth } from '../../../context/auth-context';
import { customStyles } from '../../../styles';
import SupplierStatement from '../suppliers/SupplierStatement';
import CustomerData from '../customers/customerStatement';

export default function Clients() {

    
     const [searchQuery, setSearchQuery] = useState("");
     const [isSlidingDivOpen, setIsSlidingDivOpen] = useState(false);
      const [title, setTitle] = useState('');
      const [output, setOutput] = useState('');
      const [selectedType, setSelectedType] = useState("");

    const toggleSlidingDiv = () => setIsSlidingDivOpen(!isSlidingDivOpen);


    function viewSupp(id, type, name){

        toggleSlidingDiv()
    
        if(type !=3){
          setTitle('Supplier Statement')
          setOutput(<SupplierStatement id={id} name={name} />)
        }else{
            setTitle('Supplier Statement')
            setOutput(<CustomerData id={id} name={name} />) 
        }
    
      }
   const columns = [
      {
        name: "Sn",
        selector: (row, index) => index + 1,
        width: "50px",
        center: true,
      },
      {
        name: "Names",
        selector: (row) =>`${row.name} ${" "} ${row.person !== null?row.person:''}`,
        sortable: true,
      },
      {
        name: "Contact",
        selector: (row) => row.pnumber,
      },
      {
        name: "Email",
        selector: (row) => row.email,
      },
      {
        name: "Type",
        selector: (row) => row.type==1?'Supplier':row.type==2?'Employee':'Customer',
      },
      {
        name: "Actions",
        cell: (row) => (
          <>

                  <button onClick={()=>viewSupp(row.id, row.type, row.name)} className="bg-blue-950 text-white px-2 py-2 rounded-lg m-2 text-lg"> <FaEye/> </button>
          </>
          
        ),
        button: true,
        center: true,
      },
    ];
     const {allData, setAllData} = useOutletContext();
      const auth = useAuth();
    
      const filteredData = allData.suppliers.filter(supplier => {
        const matchesSearch = supplier.name.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesType = selectedType === "" || 
          (selectedType == "1" && supplier.type == 1) ||
          (selectedType == "2" && supplier.type == 2) ||
          (selectedType == "3" && supplier.type != 1 && supplier.type != 2);
        
        return matchesSearch && matchesType;
      });
  
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center gap-4">
          <div className="bg-white/20 rounded-xl p-3">
            <FaUsers className="text-2xl" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold">Clients</h1>
            <p className="text-blue-100 text-sm mt-1">
              Combined view of suppliers, employees, and customers.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-full flex flex-col bg-white min-h-[400px] rounded-2xl p-4 md:p-6 shadow-sm border border-gray-100">
        {/* Clients Table */}
        <div id="supTable">
          {/* Filters */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
            <input
              type="text"
              placeholder="Search by name, contact or email..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className="p-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <select
              value={selectedType}
              onChange={e => setSelectedType(e.target.value)}
              className="p-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All Types</option>
              <option value="1">Supplier</option>
              <option value="2">Employee</option>
              <option value="3">Customer</option>
            </select>
          </div>

          <p className="text-xs text-gray-500 mb-2">
            A list of all clients below. Showing{" "}
              <span className="font-semibold text-gray-700">
                {filteredData.length}
              </span>{" "}
              record{filteredData.length === 1 ? "" : "s"}.
          </p>

          <div className="rounded-xl border border-gray-100 bg-white overflow-hidden">
            <div className="overflow-x-auto">
              <DataTable
                title=""
                columns={columns}
                data={filteredData}
                pagination
                highlightOnHover
                striped
                responsive
                customStyles={customStyles}
              />
            </div>
          </div>
        </div>

        <SlidingDiv
          isOpen={isSlidingDivOpen}
          onClose={toggleSlidingDiv}
          title={title}
          children={output}
        /> 
      </div>
    </div>
  );
}
